import { useEffect, useState } from 'react'

import Heading from '@ilg-totallymoney/ui/components/Heading'
import Modal from '@ilg-totallymoney/ui/components/Modal'
import Stack from '@ilg-totallymoney/ui/components/Stack'
import Text from '@ilg-totallymoney/ui/components/Text'

import useAppQueryState from '@hooks/useAppQueryState'
import useInscalarTrackEvent from '@hooks/useInscalarTrackEvent'

import BackgroundBlob from '../BackgroundBlob'
import GuaranteedCreditLimitIntroFormWrapper from '../GuaranteedCreditLimitIntroFormWrapper/GuaranteedCreditLimitIntroFormWrapper'

interface GuaranteedCreditLimitIntroModalProps {
    onCloseModal: () => void
}

const GuaranteedCreditLimitIntroModal = ({
    onCloseModal,
}: GuaranteedCreditLimitIntroModalProps) => {
    const { isReady } = useAppQueryState()
    const [showModal, setShowModal] = useState(false)
    const { trackStart } = useInscalarTrackEvent()

    useEffect(() => {
        if (isReady) {
            setShowModal(true)
        }
    }, [isReady])

    useEffect(() => {
        if (isReady) {
            trackStart({
                step: 'credit_limit_request',
                journey: 'credit_cards',
                journeyCategory: 'credit_cards',
            })
        }
    }, [isReady])

    function onClose() {
        onCloseModal()
    }

    return (
        <Modal isOpen={showModal} isFullScreen={true} onClose={onClose}>
            <>
                <BackgroundBlob />
                <Stack space="space20" mb="space30">
                    <Heading variant="80">
                        Add your minimum credit limit
                    </Heading>
                    <Text color="light" variant="100">
                        Be confident you can get the amount you need with a
                        guaranteed credit limit
                    </Text>
                </Stack>
                <GuaranteedCreditLimitIntroFormWrapper onFormClose={onClose} />
            </>
        </Modal>
    )
}

export default GuaranteedCreditLimitIntroModal
